import React from 'react';
export function SocialProofTicker() {
  const content = '★ 5,000+ FAMILIAS YA ESTÁN PROTEGIDAS ★ GUÍA ACTUALIZADA 2026 ★ INFORMACIÓN LEGAL VERIFICADA ';
  return <div className="w-full bg-[#c0392b] overflow-hidden py-3 border-y border-[#1a56a0]" data-id="element-200">
      <div className="animate-marquee flex whitespace-nowrap" data-id="element-201">
        {[...Array(6)].map((_, i) => <span key={i} className="text-white font-bold text-sm sm:text-base md:text-xl tracking-widest uppercase mx-4 font-sans flex-shrink-0" data-id="element-202">
            {content}
          </span>)}
      </div>
    </div>;
}